<template>
    <div>
      <el-row :gutter="20">
                    <el-col :span="11">
                        <div style="border: 1px solid #d9d9d9;height: 384px;border-radius: 4px;
                                overflow: hidden;background: #FFF;box-sizing: border-box;
                                position: relative; vertical-align: middle;">
                            <!-- <div class="h" style="padding: 9px 12px 9px 19px;border-bottom: 1px solid #e8e8e8;margin-bottom: 4px;">
                                <div v-html="leftTopTitle"></div>
                                <div></div>
                            </div> -->
                            <slot name="left-header"></slot>
                            <div class="b zdy-list" ref="zdyTransferTab">
                                <a-table :data-source="leftData" :columns="leftColumns"
                                    size="small"
                                    :locale="{filterConfirm: '确定',
                                    filterReset: '重置',
                                    emptyText: '暂无数据'}"
                                    :row-selection="leftRowSelection"
                                    :rowClassName="leftTabRowClassName"
                                    :expanded-row-keys.sync="leftExpandedRowKeys"
                                    :customRow="leftCustomRow"
                                    @change="leftTabChange"
                                    :rowKey="(record)=>record.key"
                                     bordered :pagination="false" :scroll="{'y':300}"
                                     ></a-table>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="2" style="display: flex;flex-direction: column;align-items: center;
                     justify-content: center;height: 384px;">
                                <el-button
                                @click="addRightZy"
                                type="primary"
                                :disabled="!leftSelectRows.length"
                                icon="el-icon-arrow-right"
                                size="mini"
                            >右移</el-button>
                            <el-button
                                @click="addLeftZy"
                                type="primary"
                                :disabled="!rightSelectRows.length"
                                icon="el-icon-arrow-left"
                                size="mini"
                                style="margin-left: 0;margin-top: 10px;"
                            >左移</el-button>
                            <el-button
                            @click="moveUp2"
                            type="primary"
                            size="mini"
                            icon="el-icon-arrow-up"
                            style="margin-left: 0;margin-top: 10px;">上移</el-button>
                            <el-button
                            @click="moveDown2"
                            type="primary"
                            size="mini"
                            icon="el-icon-arrow-down"
                            style="margin-left: 0;margin-top: 10px;">下移</el-button>
                    </el-col>
                    <el-col :span="11">
                        <div style="border: 1px solid #d9d9d9;height: 384px;border-radius: 4px;
                                overflow: hidden;background: #FFF;box-sizing: border-box;
                                position: relative; vertical-align: middle;">
                        <!-- <div class="h" style="padding: 9px 12px 9px 19px;border-bottom: 1px solid #e8e8e8;margin-bottom: 4px;">
                                <div v-html="rightTopTitle"></div>
                                <div></div>
                        </div> -->
                        <slot name="right-header"></slot>
                        <div class="b zdy-list" :style="{'height':rightContentHeight}">
                            <a-table :data-source="rightData" :columns="rightColumns"
                                size="small"
                                :locale="{filterConfirm: '确定',
                                    filterReset: '重置',
                                    emptyText: '暂无数据'}"
                                    :row-selection="rightRowSelection"
                                    :expanded-row-keys.sync="rightExpandedRowKeys"
                                    :row-key="(record)=>record.key"
                                    :customRow="rightCustomRow"
                                    @change="rightTabChange"
                                bordered :pagination="false" :scroll="{'y':300}"></a-table>
                        </div>
                        <!-- <div class="f" style="border-top:1px solid #e8e8e8;padding: 6px 10px;">
                                <el-button size="small" @click="moveUp2">上移</el-button>
                                <el-button size="small" @click="moveDown2">下移</el-button>
                        </div> -->
                        <slot name="footer"></slot>
                        </div>
                    </el-col>
      </el-row>
    </div>
</template>
<script>
/**
 * @author xiaopi
 */
export default {
    props:{
      leftTopTitle:{
        type:String,
        default:''
      },
      leftData:{
        type:Array,
        default:[]
      },
      leftColumns:{
        type:Array,
        default:[]
      },
      leftRowSelection:{
        type:Object,
        default:{}
      },
      leftTabRowClassName:{
        type:Function
      },
      leftExpandedRowKeys:{
        type:Array,
        default:[]
      },
      leftSelectRows:{
        type:Array,
        default:[]
      },
      leftCustomRow:{
        type:Function
      },
      rightTopTitle:{
        type:String,
        default:''
      },
      rightSelectRows:{
        type:Array,
        default:[]
      },
      rightData:{
        type:Array,
        default:[]
      },
      rightColumns:{
        type:Array,
        default:[]
      },
      rightRowSelection:{
        type:Object,
        default:{}
      },
      rightExpandedRowKeys:{
        type:Array,
        default:{}
      },
      rightCustomRow:{
        type:Function
      }
    },
    data(){
      return {
        rightContentHeight:""
      }
    },
    methods:{
      leftTabChange(){
        this.$emit("leftTabChange");
      },
      rightTabChange(){
        this.$emit("rightTabChange");
      },
      addRightZy(){
        this.$emit("addRightZy");
      },
      addLeftZy(){
        this.$emit("addLeftZy");
      },
      moveUp2(){
        this.$emit("moveUp");
      },
      moveDown2(){
        this.$emit("moveDown");
      }
    },
    mounted(){
        if(this.$refs.zdyTransferTab.clientHeight<380){
            this.rightContentHeight=(380-45-44)+"px";
        }else{
            this.rightContentHeight=(this.$refs.zdyTransferTab.clientHeight-45)+"px";
        }
    }
}
</script>
<style scoped lang="less">

.transfer {
  display: flex;
  .transfer_left,
  .transfer_right {
    border: 1px solid #0270c1;
    border-radius: 3px;
    height: 370px;
    header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;
      padding: 0 15px;
      border-bottom: 1px solid #0270c1;
      background: #0270c16b;
      > span {
        color: #00ffff;
      }
    }
    section {
      width: 100%;
      height: calc(100% - 40px);
      overflow-y: auto;
      padding: 15px;
      .transfer_search {
        display: flex;
        margin-bottom: 5px;
        .el-input,
        .el-select {
          flex: 1;
          &:not(:last-child) {
            margin-right: 5px;
          }
        }
      }
      .el-checkbox-group {
        width: 100%;
        ::v-deep .el-checkbox {
          width: 100%;
          height: 40px;
          display: block;
          display: flex;
          align-items: center;
          .el-checkbox__label {
            width: calc(100% - 30px);
            vertical-align: text-top;
            display: flex;
            align-items: center;
            .check_text {
              display: inline-block;
              overflow: hidden;
              text-overflow: ellipsis;
              flex: 1;
            }
          }
        }
      }
    }
  }
  .transfer_center {
    width: 180px;
    text-align: center;
    line-height: 400px;
  }
}
</style>